import { Header } from "@/presentation/components";
import { DataTable, DataTableColumn } from "@/presentation/components/common/DataTable";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";

import { useAuthContext } from "@/presentation/context";

import { routes } from "@/presentation/router";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './IncidentePage.css';
import { useRepuesto } from "@/presentation/hooks/useRepuesto";
import { formatSmartDateTime } from "@/shared/utils/dateFormaters";
import { DeleteActionDialog } from "../action/components/DeleteActionDialog";
import { formatStateR } from "@/shared/utils/formatters";

export default function RepuestosCheckPage() {
    const navigate = useNavigate();
    const { user, logout } = useAuthContext();

    const { data: repuestos, loadAll, loading, error, changeEstado } = useRepuesto();

    useEffect(() => {
        loadAll();
    }, [loadAll]);
    const [changeOpen, setChangeOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(0);


    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const handleOpenDrawer = () => {
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleLogout = async () => {
        await logout();
        setIsDrawerOpen(false);
        navigate(routes.login, { replace: true });
    };
    const copiarTexto = async (texto: string) => {
        try {
            await navigator.clipboard.writeText(texto);
            console.log('Texto copiado');
        } catch (error) {
            console.error('No se pudo copiar el texto', error);
        }
    };

    const columns: DataTableColumn<any>[] = [

        {
            key: 'nombre',
            header: 'Numero de Serie',
            render: (repuesto) => (
                <button
                    type="button"
                    className="table-link"
                    onClick={(event) => {
                        event.stopPropagation();
                        void copiarTexto(String(repuesto.nombre ?? ''));
                    }}
                >
                    {repuesto.nombre}
                </button>
            ),
        },
        {
            key: 'destino',
            header: 'Destino',
        },


        {
            key: 'cantidad',
            header: 'Cantidad',
            render: (repuesto) => (
                <button
                    type="button"
                    className="table-link"
                    onClick={(event) => {
                        event.stopPropagation();
                        void copiarTexto(String(repuesto.cantidad ?? ''));
                    }}
                >
                    {repuesto.cantidad}
                </button>
            ),
        },
        {
            key: 'fecha',
            header: 'Fecha',
            render: (repuesto) => formatSmartDateTime(repuesto.fecha),


        },
        {
            key: 'estado',
            header: 'Estado',
            render: (repuesto) => formatStateR(repuesto.estado),
        },
    ];
    const handleChange = async () => {

        changeEstado(selectedId, {
            estado: 2
        });
        await loadAll();
        setSelectedId(0);

        setChangeOpen(false);
    }







    return (
        <div>
            <Header
                title="Ubicaciones"
                onMenuClick={handleOpenDrawer}
            />

            <AppDrawer
                isOpen={isDrawerOpen}
                user={user}
                onClose={handleCloseDrawer}
                onLogout={handleLogout}
            />

            <main className="incidentes-page">


                {loading && (
                    <p className="incidentes-page__message">
                        Cargando incidentes...
                    </p>
                )}

                {error && (
                    <p className="incidentes-page__error">
                        {error}
                    </p>
                )}

                {!loading && !error && (
                    <DataTable
                        columns={columns}
                        data={repuestos}
                        onRowClick={(repuesto: any) => {
                            setSelectedId(repuesto.id);
                            if (repuesto.estado === 2) return;
                            setChangeOpen(true);
                        }}
                        emptyMessage="No hay Repuestos cargados"
                    />
                )}
            </main>
            <DeleteActionDialog
                open={changeOpen}
                title="El Repuesto será marcado como cargado"
                message="¿Seguro que quiere marcar el/los repuesto/s como cargados?"
                onClose={() => setChangeOpen(false)}
                onConfirm={handleChange}
            />

        </div>
    );
}